import api from './api';

export const getDrivers = async (params = {}) => {
  const queryParams = new URLSearchParams(params).toString();
  const response = await api.get(`/drivers?${queryParams}`);
  return response.data;
};

export const getDriverById = async (id) => {
  const response = await api.get(`/drivers/${id}`);
  return response.data;
};

export const createDriver = async (data) => {
  const response = await api.post('/drivers', data);
  return response.data;
};

export const updateDriver = async (id, data) => {
  const response = await api.put(`/drivers/${id}`, data);
  return response.data;
};

export const deleteDriver = async (id) => {
  const response = await api.delete(`/drivers/${id}`);
  return response.data;
};

export const updateDriverStatus = async (id, status, reason) => {
  const response = await api.patch(`/drivers/${id}/status`, { status, reason });
  return response.data;
};

export const recordDriverPayment = async (id, paymentData) => {
  const response = await api.post(`/performance/drivers/${id}/payments`, paymentData);
  return response.data;
};
export const getDriverStats = async (id) => {
  const response = await api.get(`/performance/drivers/${id}/stats`);
  return response.data;
};
